import HotelSearchArea from "component/HotelSearch";
import CommonBanner from "../component/Common/CommonBanner";
import { useTranslation } from "react-i18next";
import Seo from "component/Common/seo";

const HotelSearch = () => {
    const { t } = useTranslation();
    return (
        <>
            <Seo
                title="Réservation d'Hôtels | Je Voyage Ici"
                description="Trouvez et réservez votre hôtel au meilleur prix en Algérie et à l'international."
                canonical="/hotel-search"
                image="/images/preview-bg.png"
            />
            <CommonBanner
                heading={t("hotelsSearchResult")}
                pagination="Hotel search result"
            />
            <HotelSearchArea />
        </>
    );
};

export default HotelSearch;
